import { Avatar, Rate } from "antd";
import { UserOutlined } from "@ant-design/icons";

import styles from "./index.module.css";
import trash from "assets/svg/TrashRed.svg";
// import { API_ORIGIN } from "helpers/constants";
import { CustomButton } from "Components/CustomButton";
import { formatReviewDate } from "helpers/format";
import { getAvatarSrc } from "Components/UserNameRatingPhotoComponent/UserNameRatingPhotoComponent";

export type ItemReview = {
  id: string;
  comment: string;
  rating: number;
  createdAt: string;
  user: {
    firstName: string;
    lastName: string;
    avatar: string;
  };
};
type Props = {
  item: ItemReview;
  isModal?: boolean;
  onDelete: (id: string) => void;
};

const Review = ({ item, isModal, onDelete }: Props) => {
  return (
    <>
      <div className={styles.listItem}>
        {item.user?.avatar ? (
          // <img src={API_ORIGIN + "/public/avatars/" + item.user?.avatar} alt="userPhoto" width={56} height={56} />
          <img src={getAvatarSrc(item.user?.avatar)} alt="userPhoto" width={56} height={56} />
        ) : (
          <Avatar icon={<UserOutlined />} size={57.6} />
        )}
        <div className={styles.text}>
          <div className={styles.itemHeader}>
            <div>{item.user.firstName}</div>
            <div>{formatReviewDate(item.createdAt)}</div>
          </div>
          <Rate value={item.rating} disabled className={styles.ratingRate} allowHalf />

          <div className={styles.itemMessage}>{item.comment}</div>
        </div>
        {!isModal && (
          <CustomButton
            onClick={() => {
              onDelete(item.id);
            }}
            sizeButton="icon"
            typeButton="critical"
            icon={<img src={trash} alt="trash" width={16} height={16} />}
            type="primary"
            className={styles.button}
          />
        )}
      </div>
    </>
  );
};

export default Review;
